import { useMemo } from "react";
import { currentWorkDate } from "@/lib/format.ts";

export function useReferenceDate(): string {
	return useMemo(() => currentWorkDate(), []);
}
